<template>
  <div class="mb-1">
    <div class="d-flex justify-content-between align-items-start flex-wrap">
      <div>
        <h4 class="mb-50">
          {{ title }}
        </h4>
        <p
          v-if="subtitle"
          class="text-muted small mb-50"
        >
          {{ subtitle }}
        </p>
        <b-badge
          v-if="scopeLabel"
          variant="light-primary"
        >
          {{ scopeLabel }}
        </b-badge>
      </div>
      <div class="d-flex flex-wrap align-items-center">
        <b-form-checkbox
          v-if="canCompany"
          :checked="company"
          class="mr-1 mb-50"
          @change="$emit('company', $event)"
        >
          {{ $t('ledger_rep_company_toggle') }}
        </b-form-checkbox>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="rounded-pill"
          @click="$emit('print')"
        >
          {{ $t('ledger_assets_print') }}
        </b-button>
      </div>
    </div>
    <slot name="filters" />
  </div>
</template>

<script>
import { BBadge, BFormCheckbox, BButton } from 'bootstrap-vue'

export default {
  name: 'ReportHeader',
  components: { BBadge, BFormCheckbox, BButton },
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    scopeLabel: { type: String, default: '' },
    canCompany: { type: Boolean, default: false },
    company: { type: Boolean, default: false },
  },
}
</script>
